import { InjectionToken } from '@angular/core';
import { IBrandigApiProps } from '@boxx/dynamic-branding';
import { Observable } from 'rxjs';
import { UserModel } from '../models/user.model';
import {
  ILoginForm,
  ILogSessionPayload,
  ISocialLoginForm,
} from '../repositories/ILogin.repository';

export interface ILoginService {
  login(form: ILoginForm | ISocialLoginForm): Observable<UserModel>;

  socialLogin(form: ISocialLoginForm): Observable<UserModel>;

  logout(): Observable<boolean>;

  saveFCMToken(deviceId: string, deviceToken: string): Observable<any>;

  logSessionStart(payload: ILogSessionPayload): Observable<any>;

  sendPasswordRecoveryEmail(email: string): Observable<{ action: string }>;

  getSession(): Promise<UserModel>;

  getUserName(): Promise<string>;

  getThemeData(brand: string): Observable<IBrandigApiProps>;
  
  sendRecoveryCode(email: string): Observable<any>;

  deleteUser(code: string): Observable<any>;

  sendDeleteCode(email: string): Observable<any>;
  
  validateResetCode(data: any): Observable<any>;

  resetPassword(data: any): Observable<any>;

  deleteAccount(): Promise<any>;
}

export const LOGIN_SERVICE = new InjectionToken<ILoginService>('loginService');
